import type { FC } from 'react'
import { StaticImageData } from 'next/image'
import Image from 'next/image'
import gemstoneRare from '@/shop/public/shared-assets/img/gemstone_rare.png'
import gemstoneEpic from '@/shop/public/shared-assets/img/gemstone_epic.png'
import gemstoneLegendary from '@/shop/public/shared-assets/img/gemstone_legendary.png'
import gemstoneShiny from '@/shop/public/shared-assets/img/gemstone_shinylegendary.png'
import { Rarity } from '@g4g/graphql/src/shop/__generated__/globalTypes'
import toTitleCase from '@g4g/utils/src/toTitleCase'

const imgSrc: { [k in Rarity]: StaticImageData } = {
  Rare: gemstoneRare,
  Epic: gemstoneEpic,
  Legendary: gemstoneLegendary,
  ShinyLegendary: gemstoneShiny,
} as const

const RarityTag: FC<{ rarity: Rarity; size: number }> = ({ rarity, size }) => (
  <div className="flex items-center space-x-1">
    <Image src={imgSrc[rarity]} width={size} height={size} alt={rarity} />
    <span className="text-xs font-bold text-white md:text-base">{toTitleCase(rarity)}</span>
  </div>
)

export default RarityTag
